import DiagnosticsModule from '@modules/DiagnosticsModule';
import FeatureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';
import type { RtcsClient } from '@servicetitan/telecom-rtcs-client';
import {
  RTCSLifecycleEvent,
  RTCSMetricNames,
  RTCSMetricTags,
} from '../../metrics/rtcsMetrics';

function recordLifecycleEvent(event: string): void {
  if (
    !FeatureFlagModule.isEnabled(FeatureFlagKeys.featureRtcsReconnectResync)
  ) {
    return;
  }
  DiagnosticsModule.incrementCounter(
    RTCSMetricNames.RTCS_LIFECYCLE_EVENT_TOTAL,
    {
      [RTCSMetricTags.RTCS_LIFECYCLE_EVENT]: event,
    },
  );
}

/**
 * Subscribes to the three RTCS connection lifecycle callbacks and emits a
 * counter each time one fires. Callback-driven complement to
 * {@link connectionStateMonitor}: only counts, no durations.
 *
 * Returns a function that detaches all three handlers.
 */
export function subscribeLifecycleEventMetrics(client: RtcsClient): () => void {
  const unsubReconnecting = client.onReconnecting(() =>
    recordLifecycleEvent(RTCSLifecycleEvent.RECONNECTING),
  );
  const unsubReconnected = client.onReconnected(() =>
    recordLifecycleEvent(RTCSLifecycleEvent.RECONNECTED),
  );
  const unsubDisconnected = client.onDisconnected(() =>
    recordLifecycleEvent(RTCSLifecycleEvent.DISCONNECTED),
  );
  return () => {
    unsubReconnecting?.();
    unsubReconnected?.();
    unsubDisconnected?.();
  };
}
